import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles.css'
import './index.css'
import App from './App'
import Auth0ProviderWithConfig from './auth/Auth0ProviderWithConfig'
import { PermissionsProvider } from './auth/PermissionsContext'
import { BrowserRouter } from 'react-router'
import { ThemeProvider } from '@metrogistics/acertus-ui'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <Auth0ProviderWithConfig>
        <PermissionsProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PermissionsProvider>
      </Auth0ProviderWithConfig>
    </ThemeProvider>
  </React.StrictMode>,
)

